import React, { useState, useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import PageHeader from '@/components/ui/PageHeader';
import EmployeeCard from '@/components/employees/EmployeeCard';
import EmployeeForm from '@/components/employees/EmployeeForm';
import { Button } from '@/components/ui/button';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { employees } from '@/utils/mockData';
import { useSearchParams } from 'react-router-dom';

interface Employee {
  id: string;
  name: string;
  email: string;
  phone: string;
  position: string;
  department: string;
  avatar?: string;
}

const Employees: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredEmployees, setFilteredEmployees] = useState(employees);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const term = searchParams.get('search') || '';
    setSearchTerm(term);
    
    const filtered = employees.filter(employee =>
      employee.name.toLowerCase().includes(term.toLowerCase()) ||
      employee.email.toLowerCase().includes(term.toLowerCase()) ||
      employee.position.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredEmployees(filtered);
  }, [searchTerm, searchParams]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const term = e.target.value;
    setSearchTerm(term);
    
    if (term) {
      searchParams.set('search', term);
    } else {
      searchParams.delete('search');
    }
    setSearchParams(searchParams);
  };

  const handleAddEmployee = (employee: Employee) => {
    // Implement add employee logic here
    console.log('Add employee:', employee);
  };

  const handleUpdateEmployee = (employee: Employee) => {
    // Implement update employee logic here
    console.log('Update employee:', employee);
  };

  const handleDeleteEmployee = (id: string) => {
    // Implement delete employee logic here
    console.log('Delete employee:', id);
  };

  return (
    <Layout>
      <PageHeader
        title="Medewerkers"
        description="Beheer uw medewerkers en hun rollen binnen de organisatie"
        actions={
          <div className="flex space-x-2">
            <Button onClick={() => setIsFormOpen(true)}>
              Nieuwe medewerker
            </Button>
          </div>
        }
      />

      <div className="flex flex-col md:flex-row justify-between items-center mb-4">
        <div className="relative w-full md:w-1/3">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            type="search"
            placeholder="Zoek medewerkers..."
            className="pl-10"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredEmployees.map(employee => (
          <EmployeeCard
            key={employee.id}
            employee={employee}
            onUpdate={handleUpdateEmployee}
            onDelete={() => handleDeleteEmployee(employee.id)}
          />
        ))}
      </div>

      <EmployeeForm
        open={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        onAdd={handleAddEmployee}
      />
    </Layout>
  );
};

export default Employees;
